<p-card
  (click)="onNavigateToCalculation()"
  id="cdrProductShelfCalculationMenu"
  class="top-card"
>
  <div class="p-d-flex p-ai-center p-grid">
    <div class="p-d-flex p-ai-center p-col-2 p-py-0">
      <img
        src="assets/images/icon-calculator-v4.svg"
        alt=""
        class="card-icon"
      />
    </div>

    <div class="p-col-9 p-py-0">
      <div class="title" id="divProductShelfCalcutationMenuTitle">
        {{ 'loanProductShelf.calculatoinMenu.title' | transloco }}
      </div>
      <div class="description" id="divProductShelfCalcutationMenuDescription">
        {{ 'loanProductShelf.calculatoinMenu.description' | transloco }}
      </div>
    </div>
    <div class="p-d-flex p-ai-center p-col-1">
      <!-- <img
        src="/assets/images/icon_arrow_right_default.png"
        class="arrow-right"
      /> -->
      <i class="pi pi-chevron-right arrow-right"></i>
    </div>
  </div>
</p-card>
